<!-- 行内下拉菜单 -->
<template>
	<dropdown-menu
		class="m-dropdown"
		:style="{ '--menu-left': menuLeft, '--menu-right': menuRight }"
		:active-color="getUpperThemeColor"
		ref="dropMenu"
	>
		<dropdown-item ref="customItem" @open="openDropdown" @close="closeDropdown">
			<template #title>
				<slot
					v-if="hasSlotTitle"
					name="title"
					:actived="{
						value: activedValue,
						text: activedText,
						state: dropDownState
					}"
				></slot>
				<span v-else>{{ activedText }}</span>
			</template>
			<div
				v-for="(item, index) in options"
				:key="index"
				class="m-dropdown-item"
				:class="{
					'm-dropdown-item--active': item.value == activedValue
				}"
				@click="e => onChange(e, item)"
			>
				<span>{{ item.text }}</span>
			</div>
		</dropdown-item>
	</dropdown-menu>
</template>

<script setup>
import { ref, watch, nextTick, useSlots, computed } from 'vue';
import { DropdownItem, DropdownMenu } from 'vant';
import { getRect } from '@/utils/api';
import { useCommonData } from '@/hooks';

const props = defineProps({
	value: null,
	options: {
		type: Array,
		default: () => []
	},
	position: {
		type: String,
		default: 'left'
	},
	defaultText: {
		type:String,
		default: ''
	}
});

const emits = defineEmits(['update:value', 'change']);

const slots = useSlots();
const hasSlotTitle = computed(() => slots.title !== undefined);

const { getUpperThemeColor } = useCommonData();
const init = ref(true)

const activedText = ref('');
const getActivedText = () => {
	const findItem = props.options?.find(item => item.value === props.value);
	
	if (findItem) {
		activedText.value = init.value ? props.defaultText || findItem.text : findItem.text;
	} else {
		activedText.value = '-';
	}
};


const menuLeft = ref('unset');
const menuRight = ref('unset');

const dropMenu = ref(null);
watch(
	() => props.value,
	async () => {
		await nextTick();
		const rect = getRect(dropMenu.value.$el);
		if (props.position === 'left') {
			menuLeft.value = rect.left + 'px';
		} else {
			menuRight.value = document.documentElement.clientWidth - rect.right + 'px';
		}
		getActivedText();
		activedValue.value = props.value;

		if(props.defaultText) activedValue.value = 100000000000 //给初始化文案设置一个value
		init.value = false 
	},
	{ immediate: true }
);

const activedValue = ref(props.value);
const customItem = ref(null);
const onChange = (e, item) => {
	customItem.value?.toggle();

	if (activedValue.value === item.value) return;
	activedValue.value = item.value;
	activedText.value = item.text;

	emits('update:value', item.value);
	emits('change', item);
};

const dropDownState = ref('close');
const openDropdown = () => (dropDownState.value = 'open');
const closeDropdown = () => (dropDownState.value = 'close');
</script>

<style lang="less" scoped>
@import '../../style/global.less';

.m-dropdown {
	position: relative;
	/deep/ .van-dropdown-menu__bar {
		height: 100%;
		background-color: unset;
		box-shadow: unset;
		display: inline-flex;

		.van-dropdown-menu__title {
			padding: 0;
			color: var(--theme-color);

			display: inline-flex;
			align-items: center;
			font-size: 14px;

			&::after {
				display: none;
			}
		}
	}
	/deep/ .van-dropdown-item--down {
		.van-overlay {
			background: unset;
		}
		.van-dropdown-item__content {
			top: 0;
			left: var(--menu-left);
			right: var(--menu-right);
			width: auto;
			border-radius: 4px;
			box-shadow: 0px 4px 16px 0px rgba(0, 0, 0, 0.12);
		}
		.van-dropdown-item__content::-webkit-scrollbar {
            display: none; /* Chrome/Safari/Edge */
        }
	}

	.m-dropdown-item {
		padding: 0 16px;
		height: 42px;
		line-height: 42px;

		span {
			color: #222;
			/* title-4 */
			 
			font-size: 14px;
			 
			font-weight: 400;
			line-height: 18px; /* 128.571% */
		}
		&--active {
			span {
				color: var(--theme-color);
			}
		}
		& + .m-dropdown-item {
			.thinner-border(1px solid var(--border-normal-color), none, none, none);

			&::before {
				left: 10px;
				width: calc(200% - 40px);
			}
		}
	}
}
</style>
